/**
 * frontend/src/pages/valuation/_useResumeScroll.ts
 *
 * VAL-POLISH-1 item 5 — reopening Intake with required driver questions
 * still unanswered lands the seller on the first one, once, rather than
 * always the top of step 1. Split out of ValuationIntake.tsx under
 * docs/FILE_SIZE_POLICY.md (that file is already over 400 lines).
 *
 * Frozen at first render with a non-empty questionnaire+answers pair: the
 * target question_id never changes after that, even as answers change on
 * subsequent edits (brief: "once, on load").
 *
 * Follow-up (Cowork review) — the questionnaire used to resolve as soon as
 * it arrived, but driver answers hydrate later from the draft, so this
 * froze on question 1 before the real answers ever showed up. `ready` gates
 * resolution until the caller says the draft has actually settled.
 */
import { useRef } from 'react'
import type { DriverQuestionnaire } from '@/types/valuation'
import { isAnswered } from './_driverAnswers'

export function useResumeScroll(
  questionnaire: DriverQuestionnaire | null,
  answers: Record<string, string>,
  ready: boolean,
): string | null {
  const resolvedRef = useRef(false)
  const targetRef = useRef<string | null>(null)

  if (!resolvedRef.current && ready && questionnaire && questionnaire.questions.length > 0) {
    resolvedRef.current = true
    const firstUnanswered = questionnaire.questions.find(
      // WALKFIX-A AMEND-2 — a stale saved option is unanswered too.
      q => q.required && !isAnswered(q, answers),
    )
    targetRef.current = firstUnanswered ? firstUnanswered.question_id : null
  }

  return targetRef.current
}
